import Api from '@/api/index';

const Deal = {
  namespaced: true,
  state: {
    value: 'my value',

    oneDeal: null, //to store SHOW response
    allDeals: null, //to store SHOW response

    //promises results
    createDealWasGood: null,
    createDealMessage: null,
    
    updateDealWasGood: null,
    updateDealMessage: null,

     // less used
    indexDealWasGood: null,
    indexDealMessage: null,

    showDealWasGood: null,
    showDealMessage: null,
  },
  getters: {
    getStateValue: state => {
      return state.value;
    }
  },

  mutations: {
    setOneDeal(state, Deal){
      state.oneDeal = Deal // Deal.data
    },
    setAllDeals(state, Deals){
      state.allDeals = Deals // Deals.data
    },

    createResponse(state, {was_good, msg}){
      state.createDealWasGood = was_good
      state.createDealMessage = msg
      setTimeout(() => {
        state.createDealrWasGood = null
      }, 100);
    },
    updateResponse(state, {was_good, msg}){
      state.updateDealWasGood = was_good
      state.updateDealMessage = msg
      setTimeout(() => {
        state.updateDealrWasGood = null
      }, 100);
    },
    indexResponse(state, {was_good, msg}){
      state.indexDealWasGood = was_good
      state.indexDealMessage = msg
      setTimeout(() => {
        state.indexDealrWasGood = null
      }, 100);
    },
    showResponse(state, {was_good, msg}){
      state.showDealWasGood = was_good
      state.showDealMessage = msg
      setTimeout(() => {
        state.showDealrWasGood = null
      }, 100);
    },

    clearAllDeals(state){
      state.allDeals = null
    },
    clearOneDeal(state){
      state.oneDeal = null
    },
  },

  actions: {
    clearAllDeals({commit}){
      commit('clearAllDeals')
    },
    clearOneDeal({commit}){
      commit('clearOneDeal')
    },

    index(context, filter) {
      Api.Deal.index(filter)
        .then(response => response.data)
        .then(Deals => {
          context.commit('setAllDeals', Deals);
          context.commit('indexResponse', {msg: '', was_good: true});
        }).catch(function(error) {
          context.commit('indexResponse', {msg: error.response.data.errors[0], was_good: false});
          console.log(error);
        });
    },
    show(context, Deal_id) {
      return Api.Deal.show(Deal_id)
        .then(response => response.data)
        .then(Deal => {
          context.commit('setOneDeal', Deal);
          context.commit('showResponse', {msg: '', was_good: true});
          return Deal
        }).catch(function(error) {
          context.commit('showResponse', {msg: error.response.data.errors[0], was_good: false});
          console.log(error);
        });
    },
    create(context, new_Deal) {
      return Api.Deal.create(new_Deal)
        .then(response => response.data)
        .then(Deal => {
          // context.commit('setOneDeals', Deal); // not often used
          context.commit('createResponse', {msg: '', was_good: true});
          return Deal
        }).catch(function(error) {
          context.commit('createResponse', {msg: error.response.data.errors[0], was_good: false});
          console.log(error);
        });
    },
    update(context, Deal) {
      return Api.Deal.update(Deal)
        .then(response => response.data)
        .then(Deal => {
          // context.commit('setOneDeal', Deal); // not often used
          context.commit('updateResponse', {msg: '', was_good: true});
          return Deal
        }).catch(function(error) {
          context.commit('updateResponse', {msg: error.response.data.errors[0], was_good: false});
          console.log(error);
        });
    },
  }

};

export default Deal;